import
  React
from 'react';

import
  PropTypes
from 'prop-types';

import {
  Button,
  ColorSvg,
  HContainerV,
  Text
} from '@vodacom/web-common';

import {
  CustomColors,
  Icons
} from '../../constants';

export const BackButton = (props) => {

  return (

    <HContainerV
      margin={props.margin}>

      <ColorSvg
        width={'13px'}
        height={'13px'}
        src={Icons.BackArrow} />

      <Button
        onClick={props.onClick}
        maxWidth={props.maxWidth}
        activeColor={CustomColors.Black}
        activeBorderColor={CustomColors.Transparent}
        activeBackgroundColor={CustomColors.Transparent}>

        <Text
          fontSize={props.fontSize}
          fontWeight={props.fontWeight}
          color={CustomColors.Grey9}>

          {props.text}
        </Text>
      </Button>
    </HContainerV>
  );
};

BackButton.propTypes = {
  minWidth: PropTypes.string,
  margin: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string,
  maxWidth: PropTypes.string,
  fontSize: PropTypes.string,
  fontWeight: PropTypes.string
};

BackButton.defaultProps = {
  margin: '24px 0 24px 16px',
  text: 'Back',
  maxWidth: '54px',
  fontSize: '16px',
  fontWeight: 'bold'
};